<template>
  <div v-if="nodes" class="grid lg:grid-cols-3 gap-20 lg:gap-y-40">
    <ProductGridItem
      v-for="(node, i) in nodes"
      :key="i"
      :title="node.title"
      :text="node.body"
    >
      <DrupalLink
        v-if="node.link?.uri?.path"
        :to="node.link.uri.path"
        class="link icon-link arrow-icon-link mt-20"
      >
        {{ node.link.title }}
      </DrupalLink>
    </ProductGridItem>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { NodeKnowhowTeaserFragment } from '#graphql-operations'

defineProps<{
  nodes?: NodeKnowhowTeaserFragment[]
}>()
</script>
